import React from 'react';
import './CryptoForm.css'; // Import CSS for styling
import Rocket from './rocket.svg'; // Import the rocket SVG

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <img src={Rocket} alt="Rocket" className="footer-rocket" />
        </div>
        <p>
          Hey👋 I'm Francis, the creator of Rocket-Portfolio. Contact me on{" "}
          <a
            href="https://x.com/Francis10576778"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="twitter-link">Twitter</span>
          </a>.
        </p>
        <p>
          Real-Time data powered by{" "}
          <a
            href="https://www.coingecko.com/"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#31efb8' }}
          >
            CoinGecko
          </a>.
        </p>
      </div>
      <div className="footer-bottom">
        <p style={{ textAlign: 'left' }}>&copy; {new Date().getFullYear()} Rocket-Portfolio. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
